module.exports = __webpack_public_path__ + "static/apps@2x-4f5726afb22d2a76eadc973f937118a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/apple-watch-prototyping/apps@2x.jpg
// module id = 324
// module chunks = 3528254163161 126761542922144 223471745239978